<template>
	<c-dialog ref="editProductClassify" title="设置商家可用类目" width="600" height="800" @resolve="submit">
		<dl class="classify">
			<dt><c-checkbox :checked="allChecked" @click="checkHandle($event, 'all')">全选</c-checkbox></dt>
		</dl>
		<dl v-for="(classify, i) in productClassifyList" :key="i" class="classify">
			<dt><c-checkbox :checked="classify.checked" @click="checkHandle($event, classify)">{{classify.type_name}}</c-checkbox></dt>
			<dd v-if="classify.chlidren.length">
				<ul>
					<li v-for="(item, j) in classify.chlidren" :key="j"><c-checkbox :checked="item.checked" @click="checkHandle($event, item, classify)">{{item.type_name}}</c-checkbox></li>
				</ul>
			</dd>
		</dl>
	</c-dialog>
</template>

<script>
	export default {
		data() {
			return {
				productClassifyList: []
			}
		},
		
		computed: {
			allChecked() {
				return !!this.productClassifyList.length && !this.productClassifyList.find(item => {
					return !item.checked || item.chlidren.find(item => !item.checked);
				});
			}
		},
		
		mounted() {
		},
		
		methods: {
			open(stationed_ids, value) {
				if (!stationed_ids.length) {
					this.$message({
						text: '请选择需要设置可用类目的商家'
					});
					return;
				}
				
				/*value && (value = value.split(','));
				!function loop(list) {
					list.forEach(item => {
						this.$set(item, 'checked', value ? value.includes(item.id.toString()) : false);
						loop.call(this, item.chlidren);
					})
				}.call(this, this.productClassifyList);*/
				this._stationedIds = stationed_ids;
                this.update(stationed_ids);
				this.$refs.editProductClassify.open();
			},

			update(stationed_ids) {
                var stationed_id = 0;
                if (stationed_ids && stationed_ids.length == 1){
                    stationed_id = stationed_ids[0];
                }
				this.request({
					url: '/product_type/tree',
                    data:{
                        stationed_id:stationed_id
                    },
					success: data => {
						this.productClassifyList = data;
					}
				});
			},
			
			checkHandle(state, item, classify) {
				if (item == 'all') {
					this.productClassifyList.forEach(item => {
						this.$set(item, 'checked', state);
						item.chlidren.forEach(item => {
							this.$set(item, 'checked', state);
						});
					});
				} else {
					this.$set(item, 'checked', state);
					if (classify) {
						if (state) {
							this.$set(classify, 'checked', true);
						} else if (!classify.chlidren.find(item => item.checked)) {
							this.$set(classify, 'checked', false);
						}
					} else {
						item.chlidren.forEach(item => {
							this.$set(item, 'checked', state);
						});
					}
				}
			},
			
			submit(stop, next) {
				stop();
				let arr = [];
				this.productClassifyList.forEach(classify => {
					classify.checked && arr.push(classify.id);
					classify.chlidren.forEach(item => {
						item.checked && arr.push(item.id);
					});
				});
				
				if (!arr.length) {
					this.$message({
						text: '请选择分类'
					});
					return;
				}
				
				this.request({
					url: '/stationed/set_product_classify',
					data: {
                        product_type_ids: arr,
                        stationed_ids: this._stationedIds
					},
					success: data => {
						next();
						this.$message({
							text: '设置成功'
						});
						this.$emit('resolve');
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.classify {
		padding: 0 40px;
		margin: 20px 0;
		
		dt {
			padding: 5px 0;
		}
		
		dd {
			padding: 0 30px;
			
			li {
				padding: 5px 0;
			}
		}
	}
</style>
